export default "__VITE_ASSET__D0f51xyk__"